import { useEffect, useState } from 'react'

export function usePWA() {
  const [isPWA, setIsPWA] = useState(() => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
    const isFullscreen = window.matchMedia('(display-mode: fullscreen)').matches
    const isChrome =
      navigator.userAgent.includes('Chrome') &&
      !navigator.userAgent.includes('Edg')
    const isWindowsChromePWA =
      isChrome &&
      window.matchMedia('(display-mode: window-controls-overlay)').matches

    return (
      isStandalone ||
      window.navigator.standalone ||
      document.referrer.includes('android-app://') ||
      isFullscreen ||
      isWindowsChromePWA
    )
  })

  useEffect(() => {
    const mediaQueries = [
      window.matchMedia('(display-mode: standalone)'),
      window.matchMedia('(display-mode: fullscreen)'),
      window.matchMedia('(display-mode: window-controls-overlay)'),
    ]

    const handler = () => {
      const isStandalone = mediaQueries[0].matches
      const isFullscreen = mediaQueries[1].matches
      const isChrome =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      const isWindowsChromePWA = isChrome && mediaQueries[2].matches

      setIsPWA(isStandalone || isFullscreen || isWindowsChromePWA) // isPWA is true if the app runs in "native like" mode, etc it behaves like an app instead of a web page.
    }

    mediaQueries.forEach((query) => query.addEventListener('change', handler))

    return () => {
      mediaQueries.forEach((query) =>
        query.removeEventListener('change', handler),
      )
    }
  }, [])

  return isPWA
}
